import React from "react";
import HeroADF from "../Components/Hero/HeroADF";
import ADF from "../Components/Contact/ADF";

const AccountDeletionForm = () => {
  return (
    <>
      <HeroADF />
      <ADF />
    </>
  );
};

export default AccountDeletionForm;
